interface ClearFilterButtonProps {
  onClear: () => void;
}

export default function ClearFilterButton({ onClear }: ClearFilterButtonProps) {
  return (
    <button
      onClick={onClear}
      className="flex items-center justify-center gap-1 px-4 h-[38px] bg-gray-100 dark:bg-gray-800 w-full md:w-fit rounded-lg text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition"
    >
      Reset
    </button>
  );
}
